import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken,
  setToken,
  getSnsUrl
} from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({
  showSpinner: false
})

const whiteList = ['/login', '/login/index']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)
  if (getToken()) {
    if (!store.getters.cusid) {
      store.dispatch('settings/getConfigInfo')
      await store.dispatch('user/getInfo')
    }
    next()
  } else if (whiteList.indexOf(to.path) == -1) {
    if (window.navigator.userAgent.toLowerCase().match(/Alipay/i) == "alipay") {
      ap.getAuthCode({
        appId: process.env.VUE_LIFE_APPID,
        scopes: ['auth_base'],
      }, async authRes => {
        let res = await store.dispatch('user/login', authRes.authCode)
        if (res.code == 0) {
          store.dispatch('settings/getConfigInfo')
          await store.dispatch('user/getInfo')
          next()
        }
      })
    } else {
      if (to.query.token) {
        setToken(to.query.token)
        store.dispatch('settings/getConfigInfo')
        await store.dispatch('user/getInfo')
        delete to.query.token
        next({
          path: to.path,
          query: to.query,
          replace: true
        })
      } else {
        window.location.replace(getSnsUrl(window.location.href, 'snsapi_base'))
      }
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js